/**
 * A hybrid event's online link (GH-866), as the donor pages may draw it.
 *
 * The server already refuses anything but an absolute `https://` link; the page checks again with
 * the same rule before it becomes an `href`, so a stored or proxied value can never become a
 * `javascript:` link on a donor's screen.
 */
import { onlineUrlProblem } from "@givehere/contracts";

/** The link when it is safe to draw, else null. */
export function drawableOnlineUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  return onlineUrlProblem(url) === null ? url.trim() : null;
}

/** Opened in a new tab, without handing this page or its address to the destination. */
export const ONLINE_LINK_REL = "noopener noreferrer";
